export const firmWords = {
  title: 'Firm workspace',
  lead: 'Review work across practices your firm’s attorneys can access.',
  inviteTitle: 'Introduce a practice',
  inviteLead: 'Send a request to the VerityRx team. The team sets up the account and access.',
  inviteButton: 'Send request',
  inviteSaved: 'Request saved. The team will set up the account.',
  empty: 'No practices with live reviewer access yet.',
  noBinder: 'No binder yet',
  assignment: 'Assign review',
  saveAssignment: 'Save assignment',
  allAttorneys: 'All attorneys',
  due: 'Due date',
  scopeLink: 'Scope of review',
  undecided: 'undecided findings',
  highRisk: 'Requirement not met',
  needsReview: 'Needs review',
  noFlagged: 'No flagged findings',
  firmLink: 'Firm workspace',
  requestsTitle: 'Firm introductions',
  requestsLead: 'Set up each practice through the normal team flow, then link the request.',
  noRequests: 'No firm introductions are waiting.',
  addedThisQuarter: 'practices added through your firm this quarter',
  counsel: 'Counsel',
  clientRoster: 'Client roster',
  sortNote: 'Requirement not met first, then needs review; earlier due dates break ties.',
  binder: 'Binder',
  round: 'Round',
  notStarted: 'Not started',
  attorney: 'Attorney',
  chooseAttorney: 'Choose attorney',
  staleAssignment: 'The assigned attorney no longer has access. Choose someone with a live reviewer grant.',
  previous: 'Previous',
  next: 'Next',
  zeroPractices: '0 practices',
  zeroRequests: '0 requests',
  loadingPractices: 'Loading practices…',
  loadingRequests: 'Loading requests…',
  retry: 'Try again',
  notSet: 'Not set',
  saving: 'Saving…',
  sending: 'Sending…',
  practiceName: 'Practice name',
  contactEmail: 'Contact email',
  practiceType: 'Practice type',
  telehealth: 'Telehealth prescribing',
  medspa: 'Medical spa',
  team: 'VerityRx team',
  customers: 'Customers',
  addPractice: 'Add practice',
  createdPractice: 'Created practice',
  choosePractice: 'Choose practice',
  markSetUp: 'Mark set up',
} as const;
